import isEqual from 'lodash.isequal'

// Values are markdown since the editor migration. Old log entries can
// still contain Lexical JSON: extract their plain text without Lexical.
export function legacyTextValue(value: string): string {
  if (value[0] !== '{') return value
  try {
    const json = JSON.parse(value)
    if (!json?.root) return value
    const walk = (node: any): string =>
      node.text ??
      (node.children
        ? node.children
            .map(walk)
            .join(node.type === 'root' || node.type === undefined ? '\n' : '')
        : '')
    return walk(json.root)
  } catch {
    return value
  }
}

/**
 * A text as the reader sees it once displayed (#114): what the editor may
 * rewrite on its own when a field is merely saved — a `*` or `+` bullet turned
 * into `-`, trailing spaces, non-breaking spaces, extra or trailing blank lines
 * — is levelled out, so that two texts that look the same compare equal.
 */
export function displayText(value: string): string {
  return legacyTextValue(value)
    .replace(/&nbsp;| /g, ' ')
    .split('\n')
    .map((line) => line.replace(/^(\s*)[*+](\s)/, '$1-$2').replace(/\s+$/, ''))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/^\n+|\n+$/g, '')
}

// Whether two values of a field look the same to a reader
export function sameOnScreen(a: unknown, b: unknown): boolean {
  if (typeof a === 'string' && typeof b === 'string') {
    return displayText(a) === displayText(b)
  }
  return isEqual(a, b)
}
